import { Compass } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useDocuments } from "~/api/queries";
import { DocumentList } from "~/features/documents/DocumentList";
import { Text } from "~/foundation/components/Text";
import { useDocumentTitle } from "~/foundation/hooks/useDocumentTitle";

/** What the workspace is reading, as opposed to what you personally touched last. */
export function DiscoverScene() {
  const { t } = useTranslation();
  const { data: documents, isLoading } = useDocuments({ status: "published" });
  useDocumentTitle(t("Discover"));

  const mostViewed = [...(documents ?? [])].sort((a, b) => b.views - a.views);

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 p-6">
      <div>
        <Text as="h1" variant="h2">
          {t("Discover")}
        </Text>
        <Text variant="secondary" className="mt-1">
          {t("What the rest of the workspace is reading.")}
        </Text>
      </div>

      <DocumentList
        documents={mostViewed}
        isLoading={isLoading}
        emptyIcon={Compass}
        emptyMessage={t("Nothing to discover yet")}
      />
    </div>
  );
}
